// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import styles from './damageCnUnblockAndRtoDashboard.scss';
import DateRangeFilter from '../../../commons/dateFilter/dateFilter';
import SearchBox from '../../../commons/searchBox/searchBox';
import { setPageName } from '../../../../services/pageService/pageActionCreator';
import {
  filterDashboardData,
  getDashboardData,
  unblockDamagePilferageCns,
  rtoDamagePilferageCns
} from './dashboardRedux/damageCnUnblockAndRtoDashboardActionCreator';
import { jsonToCSVConvertor } from '../../../../services/helpers';
import { damageCnUnblockAndRtoDashboardConfig } from './damageCnUnblockAndRtoDashboardHelper';
import ZoomTable from '../../../commons/zoomTable/zoomTable';
import Loader from '../../../commons/loader/loader';

type Props = {
  userProfile: Object,
  setPageName: Function,
  damageCnUnblockAndRtoDashboardState: Object,
  initServiceState: Object,
  getDashboardData: Function,
  filterDashboardData: Function,
  history: Object
};

type State = {
  startDate: number,
  endDate: number,
  row: Object
};

const pageObj = {
  pageName: 'CLIENT CONFIRMATION',
  betaPage: false
};
class DamageCnUnblockAndRtoDashboard extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.componentKey = 'DAMAGE_CN_UNBLOCK_RTO_CONFIG';
    this.tableActionFunctions = {
      DAMAGE_CN_UNBLOCK_RTO_CONFIG: {
        unblockDamagePilferageCns: rowData => {
          this.unblockDamagePilferageCns(rowData);
        },
        rtoDamagePilferageCns: rowData => {
          this.rtoDamagePilferageCns(rowData);
        }
      }
    };
  }

  componentWillMount() {
    this.props.setPageName(pageObj);
  }

  onSearchValueChange(val: string) {
    this.props.filterDashboardData(val);
  }

  onDownloadClick() {
    jsonToCSVConvertor(
      (this.props.damageCnUnblockAndRtoDashboardState &&
        this.props.damageCnUnblockAndRtoDashboardState.dashboardData) ||
        [],
      'Damage or Pilferage CNs',
      damageCnUnblockAndRtoDashboardConfig.columns
    );
  }

  onDateFilterChange(start, end) {
    this.setState(
      {
        startDate: start,
        endDate: end
      },
      () => {
        this.dashboardDataCall();
      }
    );
  }

  unblockDamagePilferageCns(rowData: Object) {
    const toastrConfirmOptions = {
      okText: 'Unblock',
      title: 'Confirmation',
      cancelText: 'Cancel',
      transitionIn: 'fadeIn',
      transitionOut: 'fadeOut',
      showCloseButton: true,
      onOk: () => {
        const requestParams = {
          reasonId: rowData && rowData.reasonId,
          cnote: rowData && rowData.cnote
        };
        this.props.unblockDamagePilferageCns(requestParams, () => {
          this.dashboardDataCall();
        });
      },
      onCancel: () => {}
    };
    toastr.confirm(
      <div className={styles.toastrConfirmText}>
        Do You want to Unblock this CN ?
      </div>,
      toastrConfirmOptions
    );
  }

  rtoDamagePilferageCns(rowData: Object) {
    const toastrConfirmOptions = {
      okText: 'RTO',
      title: 'Confirmation',
      cancelText: 'Cancel',
      transitionIn: 'fadeIn',
      transitionOut: 'fadeOut',
      showCloseButton: true,
      onOk: () => {
        const requestParams = {
          reasonId: rowData && rowData.reasonId,
          cnote: rowData && rowData.cnote
        };
        this.props.rtoDamagePilferageCns(requestParams, () => {
          this.dashboardDataCall();
        });
      },
      onCancel: () => {}
    };
    toastr.confirm(
      <div className={styles.toastrConfirmText}>
        Do You want to RTO this CN ?
      </div>,
      toastrConfirmOptions
    );
  }

  dashboardDataCall() {
    const result = this.props.initServiceState.reasonList.map(x => x.id);
    if (this.state.startDate && this.state.endDate) {
      this.props.getDashboardData({
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        reasonIds: [138]
      });
    }
  }

  renderDownload() {
    return (
      <div
        className={`action-button-wrapper ${styles.download}`}
        onClick={() => this.onDownloadClick()}
      >
        <div className="action-button">Downloads</div>
      </div>
    );
  }

  renderFilterPanel() {
    return (
      <div
        className={`${styles.filterPanelParent} zt-filter-panel-parent l-row a-center`}
      >
        <div
          className={`${styles.filterPanelLeft} zt-filter-panel-left l-row flex-70`}
        >
          <div
            className={`${styles.filterLabel} zt-filter-label l-row a-center`}
          >
            Filter By:
          </div>
          {this.renderDateFilter()}
          <div
            className={`${styles.filterLabel} zt-filter-label l-row a-center`}
          />
          {this.renderDownload()}
          <div
            className={`${styles.filterLabel} zt-filter-label l-row a-center`}
          />
        </div>
        <div
          className={`${styles.filterPanelRight} zt-filter-panel-right l-row flex-30 j-end`}
        >
          {this.renderSearchBox()}
        </div>
      </div>
    );
  }

  renderDateFilter() {
    return (
      <div
        className={`${styles.filterComponentWrapper} zt-filter-component-wrapper`}
      >
        <DateRangeFilter
          setDateFilter={(start, end) => this.onDateFilterChange(start, end)}
          displayFormat="DD MMM YY"
          minusDays={Number(1)}
        />
      </div>
    );
  }

  renderSearchBox() {
    return (
      <div
        className={`${styles.filterComponentWrapper} zt-filter-component-wrapper`}
      >
        <SearchBox
          onSearchValueChange={val => this.onSearchValueChange(val)}
          resetSearchText={false}
        />
      </div>
    );
  }

  renderTable() {
    if (
      this.props.damageCnUnblockAndRtoDashboardState &&
      this.props.damageCnUnblockAndRtoDashboardState.dashboardDataFiltered &&
      !this.props.damageCnUnblockAndRtoDashboardState.isLoading
    ) {
      return (
        <div className={`${styles.tableWrapper}`}>
          <ZoomTable
            configKey={this.componentKey}
            tableData={
              (this.props.damageCnUnblockAndRtoDashboardState &&
                this.props.damageCnUnblockAndRtoDashboardState
                  .dashboardDataFiltered) ||
              []
            }
            tableDataLength={
              (this.props.damageCnUnblockAndRtoDashboardState &&
                this.props.damageCnUnblockAndRtoDashboardState
                  .dashboardDataFiltered &&
                this.props.damageCnUnblockAndRtoDashboardState
                  .dashboardDataFiltered.length) ||
              0
            }
            actionFunctions={this.tableActionFunctions[this.componentKey]}
          />
        </div>
      );
    }
    if (
      this.props.damageCnUnblockAndRtoDashboardState &&
      this.props.damageCnUnblockAndRtoDashboardState.isLoading &&
      !this.props.damageCnUnblockAndRtoDashboardState.isLoaded
    ) {
      return <Loader message="Fetching Damage/Pilferage CNs" />;
    }
    return null;
  }

  render() {
    return (
      <div className={`${styles.damagedCnUnblockAndRtoDashboardWrapper}`}>
        {this.renderFilterPanel()}
        {this.renderTable()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userProfile: state.userProfile,
  damageCnUnblockAndRtoDashboardState:
    state.damageCnUnblockAndRtoDashboardState,
  initServiceState: state.initServiceState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getDashboardData: bindActionCreators(getDashboardData, dispatch),
  filterDashboardData: bindActionCreators(filterDashboardData, dispatch),
  unblockDamagePilferageCns: bindActionCreators(
    unblockDamagePilferageCns,
    dispatch
  ),
  rtoDamagePilferageCns: bindActionCreators(rtoDamagePilferageCns, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DamageCnUnblockAndRtoDashboard);
